export class FieldConfig {
    constructor(public id?: number,
        public raceId?: number,
        public name?: string,
        public nameEng?: string,
        public nameIta?: string,
        public nameSlo?: string,
        public info?: string,
        public infoEng?: string,
        public infoIta?: string,
        public infoSlo?: string,
        public fieldConfigTypeId?: FieldConfigType,
        public options?: FieldConfigOption[],
        public registrationDisplayFlag?: number,
        public required?: boolean,
        public visibility?: number,
        public minValue?: number,
        public maxValue?: number,
        public minTextLength?: number,
        public maxTextLength?: number,
    ) {
    }
}

export class FieldConfigOption {
    constructor(
        public id?: number,
        public fieldConfigId?: number,
        public raceId?: number,
        public name?: string,
        public nameEng?: string,
        public nameIta?: string,
        public nameSlo?: string) { }
}

export enum FieldConfigType {
    BOOLEAN = 1,
    SELECT = 2,
    MULTISELECT = 3,
    TEXT = 4,
    NUMBER = 5,
    TIME = 6,
    DATE = 7,
}

